module.exports = __webpack_public_path__ + "img/wheel-white.e38ae40c.svg";